<template>
  <div id="layout">
    <nav class="top-nav">
      <v-toolbar dense>
        <img
          src="../../assets/hil-logo.png"
          alt="HiL"
          style="height: 40px"
          class="ml-1 mr-3"
        />
        <h2>Partage de bien</h2>
      </v-toolbar>
    </nav>
    <slot />
  </div>
</template>

<script>
export default {
  name: "anon-layout",
  data: function() {
    return {
      loading: false
    };
  },
  methods: {}
};
</script>
<style>
#layout {
  min-height: 100vh;
  position: relative;
}
</style>
